import { pxToRem } from 'utils/convert';

/** endpoints */
export const LIST_IMPORT_URL = '/lists/import';
export const EXPORT_UNSUBSCRIBED_URL = '/lists/exportUnsubscribed';
export const CHANNEL_SUBSCRIBE_URL = '/lists/channelSubscribe';
export const CHANNEL_UNSUBSCRIBE_URL = '/lists/channelUnsubscribe';
export const LIST_UPDATE_URL = '/lists/update';
export const LIST_UNSUBSCRIBE_URL = '/lists/unsub';
export const LIST_SIGNUP_FORM_URL = '/lists/addSubscriberForm';
export const SEGMENTATION_URL = '/segmentation';

/** folders */
export const MAX_FOLDER_NAME_LENGTH = 150;
export const FOLDER_ID_SEARCH_PARAM = 'folderId';
export const PAGE_SEARCH_PARAM = 'page';

/** table */
export const LIST_SKELETON_ROW_COUNT = 5;
export const LIST_SKELETON_HEIGHT = 50;
export const LIST_SKELETON_COLUMN_COUNT = 4;

export const TABLE_GRID = `
  minmax(${pxToRem(556)}, 1fr) // name
  ${pxToRem(128)} // type
  ${pxToRem(121)} // users
  ${pxToRem(200)} // last modified
  ${pxToRem(80)} // overflow menu
`;
